export enum CartGroupTypeEnum {
  BUNDLE = 'BUNDLE',
  STANDALONE = 'STANDALONE'
}
